ACC.schaeffImager = {

    _autoload: [
        "bindOnResizeWatcher",
    ],

    // {values: [{minWidth, value}], callback, lastElement}
    elements: [],

    bindOnResizeWatcher: function() {
        window.addEventListener('resize', ACC.schaeffImager.updateElements);
    },

    updateElements: function() {
        const len = ACC.schaeffImager.elements.length;
        for (let i=0; i<len; i++) {
            const elementData = ACC.schaeffImager.elements[i];
            ACC.schaeffImager.updateElement(elementData);
        }
    },

    updateElement: function(elementData) {
        const width = window.innerWidth;
        let selectedValue = elementData.values[0];
        const valLen = elementData.values.length;
        for (let j=0; j<valLen; j++) {
            const value = elementData.values[j];
            if (width >= value.minWidth) {
                selectedValue = value;
            } else {
                break;
            }
        }
        if (selectedValue && selectedValue.value !== elementData.lastElement) {
            elementData.lastElement = selectedValue.value;
            elementData.callback(elementData.lastElement);
        }
    },

    registerImager: function (imagerData, callback) {
        const imageData = JSON.parse(imagerData).map(function(element) {
            return {
                minWidth: element[0],
                value: element[1]
            }
        });
        imageData.sort(function(a, b) {
            return b.minWidth - a.minWidth;
        });
        const elementData = {
            callback: callback,
            lastElement: undefined,
            values: imageData
        };
        ACC.schaeffImager.elements.push(elementData);
        ACC.schaeffImager.updateElement(elementData);

    },
};